// extracted by mini-css-extract-plugin
export default {"logo":"App_logo__LfHig","App-link":"App_App-link__Xlpim","logo-spin":"App_logo-spin__dEM-k"};